import type { NsdcOrderStatus, TrackerFdfcDispatchStatus } from '@tracker/shared';

export const DISPATCH_LABEL: Record<TrackerFdfcDispatchStatus, string> = {
  not_dispatched: 'Not sent',
  dispatching: 'Sending…',
  dispatched: 'Sent',
  failed: 'Failed',
  unknown: 'Check at NSDC',
};

/** NSDC's own status for a sent order. `pending` includes "held for approval at NSDC". */
export const NSDC_STATUS_LABEL: Record<NsdcOrderStatus, string> = {
  pending: 'Awaiting NSDC release',
  dispatched: 'On the way',
  delivered: 'Delivered',
  returned: 'Returned',
  cancelled: 'Cancelled',
};
